/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/fragments-delivery-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/fragments-delivery-api-client";
import type { FragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryResponse } from "../models/FragmentsDeliveryAPIStationConfigClientGetAllStationsConfigs";

function getFragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsUrl() {
  const res = { method: 'GET', url: `/station-config/all` as const }  
  return res
}

/**
 * @summary Get all Station configs for a client (client access)
 * {@link /station-config/all}
 */
export async function fragmentsDeliveryAPIStationConfigClientGetAllStationsConfigs(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getFragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsUrl().url.toString(), ... requestConfig })  
  return res.data
}